<template>
    <div>
        <page-title>{{ $t('deliveries.list_page_title') }}</page-title>
        <deliveries-table ref="table" @company-filter="companyFilter = $event">
        </deliveries-table>
    </div>
</template>

<script>
import PageTitle from '@/components/layout/components/pageTitle'
import routeType from '@/router/routeType'
import DeliveriesTable from '@/components/pages/deliveries/Table'
import AuthMixin from '@/components/mixins/AuthMixin'

export default {
    components: {
        PageTitle,
        DeliveriesTable,
    },
    mixins: [AuthMixin],
    data() {
        return {
            routeType,
            companyFilter: null,
        }
    },
}
</script>
